import * as type from '../actions/types';

const initialState = {
  onboarding: {},
  fetching: true,
  updating: false,
  error: false,
  errorMessage: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_RESTAURANT_ONBOARDING_PENDING:
      return {
        ...state,
        onboarding: {},
        fetching: true,
        error: false,
        errorMessage: '',
      };
    case type.FETCH_RESTAURANT_ONBOARDING_SUCCESS: {
      return {
        ...state,
        onboarding: {
          ...action.payload.onboarding,
        },
        fetching: false,
        error: false,
        errorMessage: '',
      };
    }

    case type.FETCH_RESTAURANT_ONBOARDING_FAILURE:
      return {
        ...state,
        error: true,
        errorMessage: action.payload,
        fetching: false,
      };
    case type.UPDATE_RESTAURANT_ONBOARDING_PENDING:
      return {
        ...state,
        updating: true,
        error: false,
        errorMessage: '',
      };
    case type.UPDATE_RESTAURANT_ONBOARDING_SUCCESS: {
      return {
        ...state,
        onboarding: {
          ...action.payload.data,
        },
        updating: false,
        error: false,
        errorMessage: '',
      };
    }

    case type.UPDATE_RESTAURANT_ONBOARDING_FAILURE:
      return {
        ...state,
        error: true,
        errorMessage: action.payload,
        updating: false,
      };

    default:
      return state;
  }
};
